import React from 'react';
import PropTypes from 'prop-types';

import LineTitleGray from '../atoms/titles/LineTitleGray';

const PlanningInfo = ({ info, className }) => (
  <div className={className}>
    <div className="planDetailTitle">
      <LineTitleGray>旅行企画実施</LineTitleGray>
    </div>
    <div className="planDetailOtherBody">
      <div className="planDetailOtherBodyText">
        {info}
      </div>
      <img className="logoImage" src="/dpp/img/jata_kotorikyo_logo.gif" alt="旅行企画実施" />
    </div>
  </div>
);

PlanningInfo.defaultProps = {
  className: '',
};

PlanningInfo.propTypes = {
  info: PropTypes.string,
  className: PropTypes.string,
};

export default PlanningInfo;
